<template>
  <div class="message">
    <!-- Invalid Postcode -->
    <div v-if="!isValidPostcode" class="invalid-postcode">
      <p>Please enter a valid postcode</p>
    </div>

    <!-- Loading screen -->
    <div v-else-if="isloading" class="loading">
      <p style="padding-right: 10px">Loading mail</p>
      <i class="far fa-spinner-third fa-spin"></i>
    </div>

    <!-- Mail content -->
    <div class="content" v-else>
      <p>SUBJECT: {{ MPName }}, Please Help Save Our Threatened Wildlife</p>
      <br />
      <p>Dear {{ MPName }},</p>
      <br />
      <p>
        As one of your constituents, I am writing to you because I am deeply
        concerned about the future of Australia’s iconic wildlife and the places
        they call home, including in my backyard of {{ electorateName }}. Today,
        I discovered {{ electorateName }} is home to
        {{ speciesCount }} threatened species by using WWF’s My Backyard
        tool.
      </p>
      <p>
        Across Australia, there are more than 1,800 animal, plant and ecological
        communities known to be threatened and at risk of extinction. Many of
        these are found nowhere else in the world. They are uniquely Australian,
        and losing them will come at a great cost to our country.
      </p>
      <p>
        As my elected representative, I urgently want you to address the threats
        to our wildlife and the places they call home. We must act now on
        climate change, halt the destruction of our environment and reverse the
        extinction crisis before it’s too late.
      </p>
      <p>
        The call was heard loud and clear during the recent federal election -
        Australians want our government to take immediate action on climate
        change and protect our environment. Will you answer the call?
      </p>
      <br />
      <p>
        I urge you to address the state of threatened species in
        {{ electorateName }} and advocate for better protection of our wildlife
        across Australia by:
      </p>
      <ul>
        <li>
          Strengthening the Environment Protection and Biodiversity Conservation
          Act and establishing an independent and well-resourced Environment
          Protection Authority to enforce Australia’s nature laws. As part of
          the reform, Indigenous Australians’ knowledge, customs and interests
          should be recognised and valued under our national environment law.
        </li>
        <li>
          Improving monitoring, data collection and evaluation of environmental
          data including the development of a National Environmental Standard
          for Data.
        </li>
        <li>
          Agreeing to a national target to halt human-induced species
          extinctions and playing a leadership role to ensure this commitment is
          reflected in the Global Biodiversity Framework as part of COP15 in
          December 2022.
        </li>
        <li>
          Protecting 30% of Australia’s land and 30% of oceans by 2030. These
          protected areas should be ecologically representative, well-connected
          and effectively and equitably managed.
        </li>
        <li>
          Establishing a comprehensive threatened species recovery package,
          including time-bound, costed recovery plans for all threatened
          species.
        </li>
      </ul>
      <br />
      <p>
        Our wildlife and natural landscapes in Australia are what make us
        unique. Don’t let them be pushed to the brink of extinction. You have
        the power to speak up for the wildlife that call our local area home.
      </p>
      <br />
      <p>Yours Faithfully,</p>
      <p>{{ name }}</p>
      <p>{{ postcode }}</p>
      <p>{{ email }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormMessageViewer",
  data() {
    return {
      MPName: "",
      speciesCount: "",
      speciesName: "",
      isloading: false,
    };
  },
  computed: {
    name() {
      return `${this.firstName} ${this.lastName}`;
    },
  },
  watch: {
    async electorateName(electorate) {
      await this.fetchMailData(electorate);
    },
  },
  props: {
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    postcode: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    electorateName: {
      type: String,
    },
    isValidPostcode: {
      type: Boolean,
      default: false,
    },
    messageId: {
      type: String,
    },
  },

  async created() {
    await this.fetchMailData(this.electorateName);
  },

  methods: {
    async fetchMailData(electorate) {
      if (electorate) {
        this.isloading = true;

        // Get MP
        const mp = await this.$store.dispatch("getMp", electorate);
        if (mp) {
          this.MPName = mp.name;

          // Find species count
          const [electorateData, heroSpecies] = await Promise.all([
            this.$store.dispatch("getElectoratesGrade", [electorate]),
            this.$store.dispatch("getHeroSpecies", electorate),
          ]);

          this.speciesCount =
            electorateData[0].numberofthreatenedspeciesinelectorate;

          // Get heroSpecies
          this.speciesName = heroSpecies.commonName;
        }

        this.isloading = false;

        // // Fetch the content of the messages
        // if (this.messageId) {
        //   this.$store
        //     .dispatch("getContentMessageById", this.messageId)
        //     .then((value) => {
        //       console.log("value", value);
        //       if (value) {
        //         this.letterContent = value.content;
        //       } else {
        //         this.letterContent = "";
        //       }
        //     });
        // }
      }
    },
  },
};
</script>

<style scoped>
.message {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

p {
  color: #fff;
}

li {
  color: #fff;
}

.loading {
  display: flex;
  flex-direction: row;
  color: #fff;
  justify-content: center;
}

.invalid-postcode {
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  color: var(--wwfWhite);
  background-color: var(--errorColor);
  border-radius: 4px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// MessageViewer.vue?0b384830